<template>
  <v-container fluid class="pt-0">
    <span v-html="compiledHtml"></span>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Help',
  data() {
    return {
      fileName: "help.html",
      input: ""
    }
  },
  activated() {
    this.$store.commit('setCrumbs', [
      {text: 'help', disabled: true},
    ])
  },
  created() {
    this.loadFile()
  },
  computed: {
    compiledHtml: function() {
      return this.input;
    }
  },
  methods: {
    loadFile() {
      axios.get("/static/" + this.fileName)
        .then(result => {
          this.input = result.data;
        })
    }
  },
}
</script>

<style scoped>
.link {
  color: #1b8044;
  text-decoration: none;
}
</style>